import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, OnChanges, SimpleChanges, inject, ChangeDetectionStrategy } from "@angular/core";
import { WizardComponent } from "./wizard";
import { NgClass } from "@angular/common";

@Component({
  selector: "fh-wizard-step",
  host: {
    "[style.display]": 'isCurrent ? "block" : "none"',
  },
  template: `
    <div
      [ngClass]="{
        'modal-inner': padding === true,
        'modal-inner-smallpadding': padding === false,
      }"
    >
      <ng-content> </ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class WizardStepComponent implements OnInit, OnChanges {
  private cd = inject(ChangeDetectorRef);
  private parent = inject(WizardComponent);

  protected isCurrent;
  private step;

  @Input() stepTitle = "";
  @Input() icon = "fa-microchip";
  @Input() disabled = false;
  @Input() validate: any = false;
  @Input() padding = true;

  @Output() open = new EventEmitter();

  ngOnInit() {
    if (!this.disabled) {
      this.step = this.parent.addStep(this.stepTitle, this.icon, this.disabled, this.validate, this.padding);
      this.isCurrent = this.step === this.parent.step;

      if (this.isCurrent) {
        this.open.emit();
      }

      this.parent.stepChange.subscribe((step) => {
        this.isCurrent = this.step === step;
        if (this.isCurrent) {
          this.open.emit();
        }
        this.cd.markForCheck();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["validate"] && changes["validate"].firstChange == false) {
      const currentStep = this.parent.steps.filter((x) => x.id === this.step)[0];
      currentStep.validate = this.validate;
    }
  }
}
